import Vue from "vue";

import './plugins';
import './filters';
import './directives';
import './global/modules';
import './global/helpers';
import './global/const';

import { Pages } from "./pages";
import { Components } from "./components";
import { Body } from "./global/functions";
import {store, Store} from './store';
import CustomAcl from './customAcl.js';

let EventBusPlugin = require('vue-eventbus2/plugin');

Vue.use(EventBusPlugin);
Vue.use(CustomAcl);
Vue.mixin({
    methods: {
        capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
        v_s_convert: obj => _.map(obj, function (item, key) {
            return {
                text: item,
                value: key
            }
        })
    }
})
const app = new Vue({
    el: '#app',
    store: Store,
    components: {
        ...Pages,
        ...Components
    },

    ...Body
});


